module.exports = __webpack_public_path__ + "assets/img/4.706b63ec.jpg";